import { render } from "./FooterLeft.vue?vue&type=template&id=3ac05879&scoped=true"
import script from "./FooterLeft.vue?vue&type=script&lang=js"
export * from "./FooterLeft.vue?vue&type=script&lang=js"

import "./FooterLeft.vue?vue&type=style&index=0&id=3ac05879&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac05879"]])

export default __exports__